function eventApprovalMode(business={},service={}){
 const priceType=String(service.priceType || service.pricingType || '').toLowerCase();
 if(['quote','cotizacion','cotización'].includes(priceType))return 'manual';
 if(['auto','manual'].includes(service.eventApprovalMode))return service.eventApprovalMode;
 const settings=business.calendarSettings || {};
 const mode=String(settings.approvalMode || settings.onlineApprovalMode || business.bookingApprovalMode || business.approvalMode || 'manual').trim().toLowerCase();
 return ['auto','automatic','automatico','automático'].includes(mode)?'auto':'manual';
}
module.exports={eventApprovalMode};
